import { ref, watch, onUnmounted } from 'vue'

export function useCalendarState() {
  const showPickupCalendar = ref(false)
  const showDropoffCalendar = ref(false)

  const openPickupCalendar = () => {
    showPickupCalendar.value = true
    showDropoffCalendar.value = false
  }

  const openDropoffCalendar = () => {
    showDropoffCalendar.value = true
    showPickupCalendar.value = false
  }

  const closePickupCalendar = () => {
    showPickupCalendar.value = false
  }

  const closeDropoffCalendar = () => {
    showDropoffCalendar.value = false
  }

  const closeAllCalendars = () => {
    closePickupCalendar()
    closeDropoffCalendar()
  }

  // Handle outside clicks
  const handleOutsideClick = (event: Event) => {
    const target = event.target as Element
    if (!target.closest('.date-picker-container')) {
      closeAllCalendars()
    }
  }

  watch(showPickupCalendar, (newValue) => {
    if (newValue) {
      document.addEventListener('click', handleOutsideClick)
    } else {
      document.removeEventListener('click', handleOutsideClick)
    }
  })

  watch(showDropoffCalendar, (newValue) => {
    if (newValue) {
      document.addEventListener('click', handleOutsideClick)
    } else {
      document.removeEventListener('click', handleOutsideClick)
    }
  })

  onUnmounted(() => {
    document.removeEventListener('click', handleOutsideClick)
  })

  return {
    showPickupCalendar,
    showDropoffCalendar,
    openPickupCalendar,
    openDropoffCalendar,
    closePickupCalendar,
    closeDropoffCalendar,
    closeAllCalendars
  }
} 